module.exports = __webpack_public_path__ + "static/img/swiper_08.695b986.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/hjwq/refluxCustomer/swiper_08.png
// module id = vwB7
// module chunks = 1